import React from 'react'
import { Link } from 'gatsby'
import { Intro, Layout, Header, SectionTitle } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Elevation defines how content is presented along the z-axis of a
            design. All objects will exist within one of the panes, levels or
            nested distances described in the structure below. Different{' '}
            <Link
              class="link"
              to={'/' + data.site + '/utilities/shadow/develop'}
            >
              shadow
            </Link>{' '}
            sizes communicate the distance between an elevated object and the
            pane behind it.
          </p>
        </Intro>
        <SectionTitle>Structure</SectionTitle>
        <table>
          <th width="20%">Elevation</th>
          <th>Description</th>
          <th width="20%">Shadow Size</th>
          <tr>
            <td>Foundational Pane</td>
            <td>Used to present the main content of any design.</td>
            <td>None</td>
          </tr>
          <tr>
            <td>Attention Pane</td>
            <td>
              Used to elevate important information a large distance above the
              foundational pane. Usually these are objects that require user
              action or attention, such as the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/modal/develop'}
              >
                modal
              </Link>{' '}
              pattern or{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/notifications/develop'}
              >
                notification
              </Link>{' '}
              component.
            </td>
            <td>Large</td>
          </tr>
          <tr>
            <td>Interaction Level</td>
            <td>
              Used to elevate interactive elements above either the foundational
              or attention pane. Usually these are objects that appear when
              triggered by a user action, such as the dropdown of the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/select/develop'}
              >
                select
              </Link>{' '}
              component.
            </td>
            <td>Small</td>
          </tr>
          <tr>
            <td>Frame Level</td>
            <td>
              Used to elevate framing elements above either the foundational or
              attention pane. Usually these are objects that will remain fixed
              while the main content scrolls, such as the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/patterns/header/develop'}
              >
                header
              </Link>{' '}
              pattern or{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/autosave/develop'}
              >
                autosave
              </Link>{' '}
              component.
            </td>
            <td>Medium</td>
          </tr>
          <tr>
            <td>Artifical Elevation</td>
            <td>
              Used to create the appearance of visual depth within any level or
              pane without actually elevating any of the objects.
            </td>
            <td>Small</td>
          </tr>
        </table>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          The shadow size associated with an elevated object will remain fixed,
          even if it scrolls over or spans across two or more surfaces behind
          it. Objects that are artificially elevated within any pane or level
          will stay flush with their parent container. This means they will
          scroll under any objects that their parent container scrolls under, no
          matter how elevated they appear to be.
        </p>
      </Layout>
    </>
  )
}
